import { AudioInputState, Cover, SelectedFileNoDates } from "@/types/types";
import { stringifyDatesSelectedFileCover } from "@/utils/serverClientSerialization/stringifyDatesSelectedFileCover";

export const stringifyDatesSelectedFileCovers = (
  selectedFileCovers: NonNullable<AudioInputState["selectedFileCover"]>[]
): (Cover | SelectedFileNoDates)[] => {
  const newSelectedFileCovers = selectedFileCovers.map((selectedFileCover) => {
    return stringifyDatesSelectedFileCover(selectedFileCover);
  });

  return newSelectedFileCovers;
};
